var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15517_12139)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61095 16.9444C8.61095 17.4046 8.23785 17.7777 7.77762 17.7777H7.49984C5.8123 17.7777 4.44428 16.4097 4.44428 14.7222V4.44439C4.44428 4.13757 4.19555 3.88883 3.88873 3.88883C3.42849 3.88883 3.05539 3.51574 3.05539 3.0555C3.05539 2.59526 3.42849 2.22217 3.88873 2.22217H13.3332C14.5605 2.22217 15.5554 3.21709 15.5554 4.44439V13.611C15.5554 14.0713 15.1823 14.4444 14.7221 14.4444C14.2618 14.4444 13.8887 14.0713 13.8887 13.611V4.44439C13.8887 4.13756 13.64 3.88883 13.3332 3.88883H6.04094C6.08664 4.0664 6.11095 4.25256 6.11095 4.44439V14.7222C6.11095 15.4892 6.73278 16.111 7.49984 16.111H7.77762C8.23785 16.111 8.61095 16.4841 8.61095 16.9444Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77762 6.38883C7.77762 5.92859 8.15071 5.55549 8.61095 5.55549H11.3887C11.849 5.55549 12.2221 5.92859 12.2221 6.38883C12.2221 6.84906 11.849 7.22216 11.3887 7.22216H8.61095C8.15071 7.22216 7.77762 6.84906 7.77762 6.38883Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77762 9.72216C7.77762 9.26192 8.15071 8.88883 8.61095 8.88883H11.3887C11.849 8.88883 12.2221 9.26192 12.2221 9.72216C12.2221 10.1824 11.849 10.5555 11.3887 10.5555H8.61095C8.15071 10.5555 7.77762 10.1824 7.77762 9.72216Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 4.44438C1.6665 3.21708 2.66143 2.22217 3.88873 2.22217C5.11603 2.22217 6.11095 3.21709 6.11095 4.44439V8.61105C6.11095 9.07129 5.73785 9.44438 5.27762 9.44438H2.49984C2.0396 9.44438 1.6665 9.07129 1.6665 8.61105V4.44438ZM3.88873 3.88883C3.5819 3.88883 3.33317 4.13756 3.33317 4.44438V7.77771H4.44428V4.44439C4.44428 4.13757 4.19555 3.88883 3.88873 3.88883Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88873 13.611C8.88873 13.1508 9.26182 12.7777 9.72206 12.7777H17.7776C18.2379 12.7777 18.6109 13.1508 18.6109 13.611V15.2777C18.6109 16.6584 17.4917 17.7777 16.1109 17.7777H7.49984C7.0396 17.7777 6.6665 17.4046 6.6665 16.9444C6.6665 16.4841 7.0396 16.111 7.49984 16.111C8.2669 16.111 8.88873 15.4892 8.88873 14.7222V13.611ZM10.2222 16.111H16.1109C16.5712 16.111 16.9443 15.738 16.9443 15.2777V14.4444H10.5554V14.7222C10.5554 15.2223 10.4352 15.6943 10.2222 16.111Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15517_12139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeContract);
export default __webpack_public_path__ + "static/media/iconTypeContract.52c5558cc1486926490bd2ed0ed5a981.svg";
export { ForwardRef as ReactComponent };